<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

  <div class="content-page">
    <div class="content">
      <div class="dashboard-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/submit-invoice">Submit Invoice</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/invoice-preview">Invoice Preview</a>
            </span>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="pane-header">
                    <h4 class="my-3">Submit Invoice</h4>
                  </div>
                  <form [formGroup]="digitalInvoice" (ngSubmit)="onSubmitDigitalInvoice()">
                    <div class="row">
                      <div class="col-7">
                        <div class="form-wrapper pb-3">
                          <div class="form-header pb-4">
                            <h6 class="mb-3">Invoice Header Details Extracted</h6>
                            <p>Review invoice data extracted and submit</p>
                            <ng-container *ngIf="invalidDate">
                              <div *ngIf="dateError" class="alert alert-danger" role="alert">
                                <p>Invalid Date format, please correct date before submitting. [dd/mm/yyyy]</p>
                              </div>
                            </ng-container>
                            <div *ngIf="hasError" class="alert alert-danger" role="alert">
                              {{ error }}
                              <!-- <ng-container *ngIf="responseData.raw === undefined">
                                <p>
                                  {{ responseData.message }}
                                </p>
                              </ng-container>

                              <ng-container *ngIf="responseData.status === 'error'">
                                <p>
                                  {{ responseData.msg }}
                                </p>
                              </ng-container>

                              <ng-container *ngIf="responseData.raw !== undefined">
                                <ul *ngFor="let error of responseData.raw.errors">
                                  <li>
                                    {{ error }}
                                  </li>
                                </ul>
                              </ng-container> -->
                            </div>

                            <div *ngIf="fileSizeError" class="alert alert-danger" role="alert">
                              <p>The file size is not supported. File must not exceed 100mb.</p>
                            </div>
                            <div *ngIf="fileTypeError" class="alert alert-danger" role="alert">
                              <p>The file type is invalid. File must be a pdf</p>
                            </div>
                            <div *ngIf="totalSizeError" class="alert alert-danger session-text text-center" role="alert">
                              <span>The total size of all files exceeds the maximum allowed size of 100MB. </span>
                            </div>
                          </div>
                          <div class="invoice-data">
                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Tax Registration Number</label>
                              </div>
                              <div class="col-8">
                                <p>{{ digitalInvoice.get("SellerGstin")?.value }}</p>
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Invoice No. </label>
                              </div>
                              <div class="col-8">
                                <p class="help-block" *ngIf="digitalInvoice.get('DocNo')?.errors?.['required'] && digitalInvoice.get('DocNo')?.touched">Invoice number is required</p>
                                <input type="text" class="form-control" placeholder="eg. IAHCT2105017043" formControlName="DocNo" />
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Invoice Date </label>
                              </div>
                              <div class="col-8">
                                <p class="help-block" *ngIf="digitalInvoice.get('DocDt')?.errors?.['required'] && digitalInvoice.get('DocDt')?.touched">Invoice date is required</p>
                                <input type="text" class="form-control" placeholder="dd/mm/yyyy" formControlName="DocDt" />
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Invoice Amount </label>
                              </div>
                              <div class="col-8">
                                <p class="help-block" *ngIf="digitalInvoice.get('TotInvVal')?.errors?.['required'] && digitalInvoice.get('TotInvVal')?.touched">Invoice amount is required</p>
                                <p class="help-block" *ngIf="digitalInvoice.get('TotInvVal')?.errors?.['pattern']">
                                  Invoice amount must to 2 decimal places [00,000.00]
                                </p>
                                <input type="text" class="form-control" placeholder="eg. 2,00,000.00" formControlName="TotInvVal" />
                              </div>
                            </div>

                            <ng-container *ngIf="irnExist">
                              <div class="row g-3 align-items-center my-2">
                                <div class="col-4">
                                  <label class="col-form-label">IRN </label>
                                </div>
                                <div class="col-8">
                                  <p>{{ digitalInvoice.get("Irn")?.value }}</p>
                                </div>
                              </div>
                            </ng-container>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Email Address</label>
                              </div>
                              <div class="col-8">
                                <input type="email" class="form-control" placeholder="eg. johndoe@domain.com" formControlName="emailAddress" readonly />

                                <p class="help-block" *ngIf="digitalInvoice.get('emailAddress')?.errors?.['required'] && digitalInvoice.get('emailAddress')?.touched">Email Address required</p>
                                <p class="help-block" *ngIf="digitalInvoice.get('emailAddress')?.errors?.['pattern'] && digitalInvoice.get('emailAddress')?.touched">
                                  Please enter a valid email address
                                </p>
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Username </label>
                              </div>
                              <div class="col-8">
                                <input type="text" class="form-control" placeholder="eg. johndoe" formControlName="username" readonly />
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">User ID </label>
                              </div>
                              <div class="col-8">
                                <input type="text" class="form-control" placeholder="eg. johndoe" formControlName="userID" readonly />
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Document Category</label>
                              </div>
                              <div class="col-8">
                                <select class="form-select" formControlName="docType">
                                  Choose Company Code
                                  <option *ngFor="let doc of docs" [ngValue]="doc.docType">
                                    {{ doc.description }}
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Purchase Org</label>
                              </div>
                              <div class="col-8">
                                <select class="form-select" formControlName="purchaseOrg">
                                  Select Location JSW GBS

                                  <option *ngFor="let organisation of organisations" [ngValue]="organisation.purchaseOrganization">
                                    {{ organisation.purchaseOrganization }}
                                    -
                                    {{ organisation.description }}
                                  </option>
                                </select>
                              </div>
                            </div>

                            <div class="row g-3 align-items-center my-2">
                              <div class="col-4">
                                <label class="col-form-label">Company Code</label>
                              </div>
                              <div class="col-8">
                                <select class="form-select" formControlName="companyCode">
                                  Select Company Name

                                  <option *ngFor="let company of companies" [ngValue]="company.companyCode">
                                    {{ company.companyCode }}
                                    -
                                    {{ company.companyName }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-5">
                        <div class="form-header pb-4">
                          <div class="row">
                            <div class="col-7">
                              <h6 class="mb-3">Invoice Preview</h6>
                            </div>
                            <div class="col-5">
                              <div class="icon-wrapper re-upload">
                                <label for="invoice-resubmit" class="change-invoice">
                                  <i class="ri-upload-cloud-2-line"></i>
                                  Change Invoice
                                </label>
                                <input type="file" id="invoice-resubmit" class="form-control" #fileInput (change)="reUploadInvoice($any($event).target.files)" />
                              </div>
                            </div>
                          </div>
                          <div class="preview-pane">
                            <ng-container *ngIf="!isInvoiceChange">
                              <ngx-extended-pdf-viewer [src]="pdfSrc" [height]="'380px'" [useBrowserLocale]="true"> </ngx-extended-pdf-viewer>
                            </ng-container>
                            <ng-container *ngIf="isInvoiceChange">
                              <ngx-extended-pdf-viewer [src]="pdfSrc" [height]="'380px'" [useBrowserLocale]="true"> </ngx-extended-pdf-viewer>
                            </ng-container>
                          </div>
                          <div class="supporting-docs-pane">
                            <h6>Supporting Documents</h6>

                            <p *ngIf="!supportingDocsAdded" class="help-block">Supporting documents are required</p>

                            <div class="drop-pane">
                              <div class="row">
                                <div class="col-md-12 text-center">
                                  <div class="fileupload documents" appDragNDrop (click)="supportingFiles.click()" (fileDropped)="selectDocuments($event)">
                                    <span class="files-wrapper"><i class="ri-file-pdf-line"></i> </span>
                                    <span class="ddinfo">Drag and Drop File(s) Here</span>
                                    <p class="ddsperator mt-3">OR</p>
                                    <label for="file-upload" class="custom-file-upload">
                                      <i class="ri-upload-cloud-2-line"></i>
                                      Choose File(s) to Upload
                                    </label>
                                    <input
                                      id="supportingFiles"
                                      class="form-control"
                                      type="file"
                                      multiple
                                      formControlName="supportingFiles"
                                      #supportingFiles
                                      (change)="selectDocuments($any($event).target.files)"
                                    />
                                  </div>
                                </div>
                                <div class="col-md-12">
                                  <div *ngIf="typeError" class="alert alert-danger session-text text-center" role="alert">
                                    <span>The file type is invalid. Files must be pdfs</span>
                                  </div>
                                  <div *ngIf="sizeError" class="alert alert-danger session-text text-center" role="alert">
                                    <span>The file size is not supported. A single File must exceed 25mb. </span>
                                  </div>
                                  <div *ngIf="totalSizeError" class="alert alert-danger session-text text-center" role="alert">
                                    <span>The total size of all files (including invoice) exceeds the maximum allowed size of 100MB. </span>
                                  </div>

                                  <div class="document-pane" *ngIf="supportingDocuments.length !== 0">
                                    <p class="align-right mt-3 mb-3">
                                      Files Selected:
                                      {{ supportingDocuments.length }}
                                    </p>
                                    <div cdkDropList (cdkDropListDropped)="onDrop($event)">
                                      <div *ngFor="let file of supportingDocuments; let i = index" cdkDrag class="mt-2 drag-pane-wrapper">
                                        <div class="row">
                                          <div class="col-md-10">
                                            <span class="file-number">{{ i + 1 }}. </span>
                                            <span>
                                              {{ file.name }}
                                            </span>
                                          </div>
                                          <div class="col-md-2">
                                            <span class="delete" (click)="deleteFile(i)">
                                              <i class="ri-close-line"></i>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <p class="note-mute">These files shall be processed in the order which they are currently presented, drag your uploaded file up or down to reorder.</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mt-2 mb-3">
                        <div class="row">
                          <div class="col-12">
                            <div class="form-check mt-2 mb-4">
                              <div class="check-pane float-end">
                                <input class="form-check-input" type="checkbox" id="flexCheckDefault" formControlName="terms_agreed" (click)="checkSupportingDocuments()" />
                                <label class="form-check-label" (click)="open(validateModal)">
                                  Accept
                                  <span>Terms and Conditions</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="btn-pane float-end">
                              <button [disabled]="!(canSubmitForm && digitalInvoice.valid)" class="btn submit preview">Submit Invoice</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="loader-wrapper" *ngIf="loading">
                <ng-container *ngIf="!formSubmitted">
                  <div class="loader-content loading">
                    <div class="my-3 user-prompt">
                      <h1>Confirm</h1>
                      <h4>Are you sure you want to exit?</h4>
                      <div class="loader-text">
                        <p>You will have to start invoice submission again.</p>
                      </div>
                      <div class="loader-cta my-3">
                        <button class="btn" (click)="exitForm()">Exit</button>
                        <button class="btn btn-success" (click)="cancelExit()">Cancel</button>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="invoiceChanged">
                  <div class="loader-content loading">
                    <div class="loader-pane-processing my-4">
                      <h1 class="mb-3">
                        {{ dsLoaderMsg }}
                      </h1>
                      <div class="processing">
                        <div class="rectangle_1"></div>
                        <div class="rectangle_2"></div>
                        <div class="rectangle_3"></div>
                        <div class="rectangle_4"></div>
                        <div class="rectangle_5"></div>
                        <div class="rectangle_6"></div>
                        <div class="rectangle_7"></div>
                        <div class="rectangle_8"></div>
                        <div class="rectangle_9"></div>
                        <div class="rectangle_10"></div>
                        <div class="rectangle_11"></div>
                        <div class="rectangle_12"></div>
                        <div class="rectangle_13"></div>
                        <div class="rectangle_14"></div>
                        <div class="rectangle_15"></div>
                        <div class="rectangle_16"></div>
                        <div class="rectangle_17"></div>
                        <div class="rectangle_18"></div>
                        <div class="rectangle_19"></div>
                        <div class="rectangle_20"></div>
                      </div>
                      <p class="my-2">Please wait a few minutes</p>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="saving && !uploadInvoice">
                  <div class="loader-content loading">
                    <div class="loader-text">
                      <span class="ml-2">Saving Invoice</span>
                      <p class="text-white my-4">Please wait a few minutes</p>
                    </div>
                    <div class="loader-cta my-4">
                      <div class="placeholder-wave">
                        <span class="placeholder col-12 placeholder-sm"></span>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="uploadSuccessful">
                  <div class="loader-content success">
                    <div class="loader-text">
                      <i class="ri-checkbox-circle-fill"></i><span class="ml-2">Invoice saved and pending submission with barcode: {{ barcodeNo }}</span>
                    </div>
                    <div class="loader-cta my-4">
                      <button class="btn btn-success" (click)="closeSuccessDialog()">Done</button>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="savingError">
                  <div class="loader-content error">
                    <div class="loader-text"><i class="ri-error-warning-fill"></i><span class="ml-2 text-white">Your invoice couldn't be saved</span></div>
                    <div class="loader-cta my-4">
                      <button class="btn btn-error" (click)="closeErrorDialog()">Try Again</button>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="serverError">
                  <div class="loader-content error">
                    <div class="loader-text"><i class="ri-error-warning-fill"></i><span class="ml-2 text-white">Sorry, the request cannot be processed</span></div>
                    <div class="loader-cta my-4">
                      <button class="btn btn btn-error" (click)="closeErrorDialog()">Try Again</button>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="uploadInvoice">
                  <div class="loader-content loading">
                    <div class="loader-pane-processing my-4">
                      <h1 class="mb-3">Submitting Invoice</h1>
                      <div class="processing">
                        <div class="rectangle_1"></div>
                        <div class="rectangle_2"></div>
                        <div class="rectangle_3"></div>
                        <div class="rectangle_4"></div>
                        <div class="rectangle_5"></div>
                        <div class="rectangle_6"></div>
                        <div class="rectangle_7"></div>
                        <div class="rectangle_8"></div>
                        <div class="rectangle_9"></div>
                        <div class="rectangle_10"></div>
                        <div class="rectangle_11"></div>
                        <div class="rectangle_12"></div>
                        <div class="rectangle_13"></div>
                        <div class="rectangle_14"></div>
                        <div class="rectangle_15"></div>
                        <div class="rectangle_16"></div>
                        <div class="rectangle_17"></div>
                        <div class="rectangle_18"></div>
                        <div class="rectangle_19"></div>
                        <div class="rectangle_20"></div>
                      </div>
                      <p class="my-2">Please wait a few minutes</p>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #validateModal let-modal>
  <div class="modal-header pt-2">
    <h4 class="">Declaration</h4>
  </div>

  <div class="modal-body">
    <ul>
      <li class="mb-3">This is a legitimate tax invoice with an IRN number.</li>
      <li class="mb-3">We provide consent to JSW to validate the IRN number.</li>
      <li class="my-3">The first 3 pages of this document attached is the Tax invoice.</li>
      <li class="my-3">We have attached all the supporting documents as requested by JSW.</li>
      <li class="my-3">We agree that JSW can send the invoice back in case of validation failures.</li>
    </ul>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-white" (click)="modal.dismiss('Cross click')">Close</button>
  </div>
</ng-template>
